import React, { Component } from 'react';

import FormInput from '../Fields/FormInput.js'
import { getTranslation } from '../Utilities/GetTranslation.js'
import { postLogin } from '../Api/Register.js';

declare var globalSns;

class ApplicantWhenInterestedLogIn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      txtSiteNam: "",
      txtUserPassword: ""
    };

    this.login = this.login.bind(this);
    this.register = this.register.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
  }

  handleValueChange(e) {
    this.setState({
      [e.target.id]: e.target.value
    });
  }

  login() {
    postLogin(this.state.txtSiteNam, this.state.txtUserPassword, (data) => {
      if (data) {
        document.body.classList.add('remove-on-login-succeeded');

        this.props.onLoginSucceeded();
      } else {
        this.setState({
          loginerror: true
        });
      }
    });
  }

  register() {
    document.body.classList.add('remove-on-login-succeeded');

    this.props.onRegisterRequest();
  }

  render() {
    return (
      <div class="job-applicant-login-when-interested">
        <h3><a href="# " onClick={this.register}>{getTranslation("sns.webparts.register.register-wheninterested")}</a> {getTranslation("sns.general.or")}</h3>
        <h4>{getTranslation("sns.webparts.register.applicant-wheninterested")}</h4>

        {
          (this.state.loginerror) ?
            <span className="ErrorLabel">{getTranslation("sns.webparts.register.login.error")}</span> : ""
        }

        <div className="EditingFormTable table">
          <div className="legend">
              <FormInput id="txtSiteNam"
                    text={getTranslation("sns.webparts.register.sitenam")}
                    required={true}
                    value={this.state.txtSiteNam}
                    autoComplete="username"
                    onChange={this.handleValueChange}
                    onEnter={this.login} />
              <FormInput id="txtUserPassword"
                    text={getTranslation("sns.webparts.register.password")}
                    required={true}
                    type="password"
                    value={this.state.txtUserPassword}
                    autoComplete="current-password"
                    onChange={this.handleValueChange}
                    onEnter={this.login} />
              <div className="tr text-right">
                  <input type="button" value={getTranslation("sns.webparts.register.login")} onClick={this.login} id="loginbutton" className="FormButton btn btn-primary next" />
              </div>
              <div className="tr text-right">
                  <a href={globalSns.resetPasswordUrl}>{getTranslation("sns.webparts.register.resetpassword")}</a>
              </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ApplicantWhenInterestedLogIn;



// WEBPACK FOOTER //
// ./src/Components/ApplicantWhenInterestedLogIn.js